import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { Modal } from 'antd';
export default function Model(_a) {
    var isOpen = _a.isOpen, onDismiss = _a.onDismiss, children = _a.children;
    return (_jsx(Modal, { open: isOpen, onCancel: onDismiss, footer: null, closable: false, centered: true, maskClosable: true, style: {}, mask: true, className: 'ModelContainer', children: children }));
}
